// extracted by mini-css-extract-plugin
module.exports = {"logo":"SignInPage_logo__3ltTX","error":"SignInPage_error__2gs8E"};